import { DlCenterFile, IfDlCenterRes } from 'pages/dlcenter/dlcenter-model';
import queryString from 'query-string';
import { paxios } from 'util/axiosprgs';
import { IfSrchV3Res, SrchV3ReqBff } from './srch-v3-model';

// export const SRCH_V3_URL = '/api/guest/srch/v3/restSearch';
export const SRCH_V3_URL = '/api/guest/srch/v3/restSearchBff';
export const SRCH_V3_COUNTS_URL = '/api/guest/srch/v3/docTypeCounts';

export const srchV3ParamsSerializer = (params: Record<string, unknown> | undefined) => {
  if (!params) return;
  return queryString.stringify(params);
};

export const fetchSrchV3Res = (url: string, params: Record<string, unknown>): Promise<IfSrchV3Res> =>
  paxios.get(url, { params, paramsSerializer: srchV3ParamsSerializer }).then((res) => res.data);

export const fetchSrchV3DocTypeCounts = (params: SrchV3ReqBff): Promise<Record<string, number>> =>
  paxios.get(SRCH_V3_COUNTS_URL, { params, paramsSerializer: srchV3ParamsSerializer }).then((res) => res.data);

export const apiDlCenterResByIds = (ids: number[]): Promise<IfDlCenterRes[]> =>
  paxios.get('/api/guest/zdata/ssqdoc/dlCenter/by-ids', { params: { ids } }).then((res) => res.data);

/** ProductPage 탭 전용: description(HTML) + files 를 ssqdata DB 에서 조회. */
export interface IProductTabDocRes {
  id: number;
  description: string;
  files: DlCenterFile[];
}

export const apiProductTabDocsByIds = (ids: number[]): Promise<IProductTabDocRes[]> =>
  paxios.get('/api/guest/zdata/ssqdoc/productTab/by-ids', { params: { ids } }).then((res) => res.data);
